import { Empty, Table } from "antd";
import React from "react";
import { useState } from "react";
import { useCallback } from "react";
import { useEffect } from "react";
import AuthService from "../../services/auth.service";
import { useTranslation } from "react-i18next";
import { amountExchangeCurrencyFormat } from "../../services/common.service";
import PerfectScrollbar from "react-perfect-scrollbar";
import "../../layout/AuthLayout/authLayout.css";

export default function ExchangeRates() {
  const [dataSource, setDataSource] = useState([]);
  const [noRecords, setNoRecords] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    getallExchangeRates();
  }, []);

  const getallExchangeRates = useCallback(async () => {
    try {
      const response = await AuthService.getallExchangeRates();
      if (response.status === 200) {
        setDataSource(response.data["crossCurRateList"]);
        setNoRecords(
          response.data["crossCurRateList"].length > 0 ? false : true
        );
      }
    } catch (error) {
      setNoRecords(true);
    }
  }, []);

  return (
    <>
      <div className="" style={{ height: "inherit" }}>
        <div className="auth-card ">
          <PerfectScrollbar>
            <div className="p-4" align="center">
              <h3 align="center" className="password-text mb-5">
                {t("pages.landing.exchange", {
                  defaultValue: "Exchange Rates",
                })}
              </h3>
              <Table
                size=""
                className="exchange-rates-table"
                dataSource={dataSource}
                rowClassName={(record, index) =>
                  index % 2 === 0 ? "table-row-light" : "table-row-dark"
                }
                tableLayout="fixed"
                pagination={false}
                bordered
                sticky={true}
                columns={[
                  {
                    title: "Conversion Type",

                    key: "symbol",
                    render: (option) => 
                    <span className="d-flex align-items-center">
                      <img src={option?.flag} width={25} alt="flag" className="me-2"/>
                    <span>{option?.symbol}</span>
                    </span>,
                  },
                  {
                    title: t("pages.landing.buy_price", {
                      defaultValue: "Bank's Buy Rate",
                    }),
                    key: "buyRate",
                    width: 140,
                    align: "right",
                    render: (option) => (
                      <span>
                        {" "}
                        {amountExchangeCurrencyFormat(option?.buyRate) || "-"}
                      </span>
                    ),
                  },
                  {
                    title: t("pages.landing.sell_price", {
                      defaultValue: "Bank's Sell Rate",
                    }),
                    width: 140,
                    key: "amount",
                    align: "right",
                    render: (option) => (
                      <span>
                        {" "}
                        {amountExchangeCurrencyFormat(option?.sellRate) || "-"}
                      </span>
                    ),
                  },
                ]}
              />
            </div>
          </PerfectScrollbar>
        </div>
      </div>
    </>
  );
}
